import * as L from 'leaflet';

export interface ParamGeofenceIcon {
  color?: string;
  backgroundColor?: string;
  fontSize?: number;
  name: string;
}

export interface GeofenceNameIconOptions {
  name: string;
  textColor?: string;
  backgroundColor?: string;
  fontSize?: number;
  padding?: number;
}

export function createGeopointNameIcon(
  options: GeofenceNameIconOptions
): L.DivIcon {
  const defaults = {
    textColor: '#FFFFFF',
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    fontSize: 12,
    padding: 8,
  };

  const opts = { ...defaults, ...options };

  // Calcular el ancho dinámicamente basado en el texto
  const estimatedWidth = Math.max(
    60,
    opts.name.length * (opts.fontSize * 0.6) + opts.padding * 2
  );
  const height = opts.fontSize + opts.padding * 2;

  const html = `
    <div style="
      margin-top: 1rem;
      background: ${opts.backgroundColor};
      color: ${opts.textColor};
      font-size: ${opts.fontSize}px;
      font-weight: 600;
      font-family: system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
      padding: ${opts.padding}px;
      border-radius: 16px;
      white-space: nowrap;
      text-align: center;
      line-height: 1;
      text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.8), -1px -1px 2px rgba(255, 255, 255, 0.8), 1px -1px 2px rgba(255, 255, 255, 0.8), -1px 1px 2px rgba(255, 255, 255, 0.8);
    ">
      ${opts.name}
    </div>
  `;

  return L.divIcon({
    className: 'geofence-name-modern-icon',
    html,
    iconSize: [estimatedWidth, height],
    iconAnchor: [estimatedWidth / 2, height / 2], // centrado
    popupAnchor: [0, 0],
  });
}

export function createGeofenceNameIcon(
  options: GeofenceNameIconOptions
): L.DivIcon {
  const defaults = {
    textColor: '#FFFFFF',
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    fontSize: 12,
    padding: 8,
  };

  const opts = { ...defaults, ...options };

  // Calcular el ancho dinámicamente basado en el texto
  const estimatedWidth = Math.max(
    60,
    opts.name.length * (opts.fontSize * 0.6) + opts.padding * 2
  );
  const height = opts.fontSize + opts.padding * 2;

  const html = `
    <div style="
      background: ${opts.backgroundColor};
      color: ${opts.textColor};
      font-size: ${opts.fontSize}px;
      font-weight: 600;
      font-family: system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
      padding: ${opts.padding}px;
      border-radius: 16px;
      white-space: nowrap;
      text-align: center;
      line-height: 1;
      text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.8), -1px -1px 2px rgba(255, 255, 255, 0.8), 1px -1px 2px rgba(255, 255, 255, 0.8), -1px 1px 2px rgba(255, 255, 255, 0.8);
    ">
      ${opts.name}
    </div>
  `;

  return L.divIcon({
    className: 'geofence-name-modern-icon',
    html,
    iconSize: [estimatedWidth, height],
    iconAnchor: [estimatedWidth / 2, height / 2], // centrado
    popupAnchor: [0, 0],
  });
}

/**
 * Función legacy mantenida para compatibilidad
 * @deprecated Use createGeofenceNameIcon instead
 */
export function createGeofenceMarker(params?: ParamGeofenceIcon) {
  if (!params) {
    return createGeofenceNameIcon({ name: 'Geocerca' });
  }

  return createGeofenceNameIcon({
    name: params.name || 'Geocerca',
    textColor: params.color,
    backgroundColor: params.backgroundColor,
    fontSize: params.fontSize,
  });
}
